import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Grid, Button } from 'semantic-ui-react';
import { Formik } from 'formik';
import _ from 'lodash';

/** Services */
import ReteTutorService from 'shared/services/api/ReteTutor';
import aclService from 'shared/lib/acl';

/** Components */
import SingleSelect from '../../Forms/UI/Select';

class TutorUpdateState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        nextState: null,
      },
    };
  }

  /** Update state on DB */
  onSubmit = (values, { setSubmitting }) => {
    const state = _.isObject(values.nextState) ? values.nextState.value : values.newState;

    // Call api
    ReteTutorService.updateReteTutorState(this.props.tutor.id, state)
      .then(() => {
        this.props.notification().addNotification({
          message: 'Aggiornamento stato completato con successo',
          level: 'success',
        });
        this.props.closeModal();
        this.props.loadData();
      })
      .catch((err) => {
        // Update form
        setSubmitting(false);

        // Show message error
        this.props.notification().addNotification({
          message:
            _.get(err, 'data.detail') ||
            "Errore nell'aggiornare lo stato, se il problema persiste contatta l'assistenza",
          level: 'error',
        });
      });
  };

  /** Define options for select */
  getStateActions = () => {
    const isAreaManager = aclService.check(this.props.auth, ['responsabileArea']);
    let stateOptions = [];

    if (isAreaManager) {
      stateOptions = [
        { key: 'state-0', label: 'In preparazione', value: 0 },
        { key: 'state-1', label: 'Inviata', value: 1 },
      ];
    } else {
      stateOptions = [
        { key: 'state-0', label: 'In preparazione', value: 0 },
        { key: 'state-1', label: 'Inviata', value: 1 },
        { key: 'state-2', label: 'In lavorazione', value: 2 },
        { key: 'state-3', label: 'Non perfezionata', value: 3 },
        { key: 'state-4', label: 'Operativa', value: 4 },
      ];
    }

    stateOptions = stateOptions.filter((item) => item.value !== this.props.tutor.state);

    return stateOptions;
  };

  render() {
    const { closeModal } = this.props;
    const { initialValues } = this.state;

    return (
      <Modal.Content>
        <Formik enableReinitialize initialValues={initialValues} onSubmit={this.onSubmit}>
          {({ isSubmitting, handleSubmit, setFieldTouched, setFieldValue, touched, values }) => (
            <Form autoComplete="off" onSubmit={handleSubmit} loading={isSubmitting}>
              <Grid>
                <Grid.Row>
                  <Grid.Column key="form-update-state">
                    <SingleSelect
                      label="Stato"
                      name="nextState"
                      onBlur={(name, isTouched) => setFieldTouched(name, isTouched)}
                      onChange={(name, value) => setFieldValue(name, value)}
                      options={this.getStateActions()}
                      touched={touched.nextState}
                      value={values.nextState}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Column width={8} textAlign="left">
                  <Button.Group>
                    <Button
                      onClick={closeModal}
                      type="button"
                      icon="delete"
                      labelPosition="right"
                      content="Chiudi"
                      style={{ marginRight: '20px', width: '150px' }}
                    />
                  </Button.Group>
                </Grid.Column>
                <Grid.Column width={8} textAlign="right">
                  <Button
                    loading={isSubmitting}
                    onClick={handleSubmit}
                    type="button"
                    icon="save"
                    labelPosition="right"
                    positive
                    disabled={isSubmitting}
                    content="Salva"
                    style={{ width: '150px' }}
                  />
                </Grid.Column>
              </Grid>
            </Form>
          )}
        </Formik>
      </Modal.Content>
    );
  }
}

TutorUpdateState.propTypes = {
  /** Function to reload list of tutor */
  loadData: PropTypes.func,
  /** Funtion to close modal  */
  closeModal: PropTypes.func,
  /** Current tutor data */
  tutor: PropTypes.object,
  /** Function to notificate */
  notification: PropTypes.func,
  /** Object with data of logged user */
  auth: PropTypes.object,
};

export default TutorUpdateState;



// WEBPACK FOOTER //
// ./app/components/TutorList/TutorUpdateState/index.js